import { useEffect, useRef } from "react";
import { useLocation } from "react-router";

import { useInitializeUser } from "@/api/onboarding/user-initialized";
import { Button } from "@/components/ui/button";
import useUpdateQueryParams from "@/hooks/use-update-query-params";
import useGlobalLoading from "@/store/global-loading";
import LookAndFeel from "@/app/app/chat-settings/look-and-feel";

const Step3 = () => {
    const updateQueryParams = useUpdateQueryParams();
    const location = useLocation();
    const { setIsLoading } = useGlobalLoading();

    const hasClearedQueryParams = useRef(false); // Prevents multiple updates

    const { mutate: initializeUser, isSuccess, isPending } = useInitializeUser();

    const handleSave = () => {
        initializeUser();
    };

    useEffect(() => {
        setIsLoading(isPending);

        if (isSuccess && !isPending && !hasClearedQueryParams.current) {
            const searchParams = new URLSearchParams(location.search);
            const firstVisit = searchParams.get("first_visit");
            const step = searchParams.get("step");

            if (firstVisit !== null || step !== null) {
                updateQueryParams({ first_visit: undefined, step: undefined });
                hasClearedQueryParams.current = true; // Ensure it runs only once
            }
        }

        return () => setIsLoading(false);
    }, [isSuccess, isPending, location.search, setIsLoading, updateQueryParams]);

    return (
        <>
            <div className="flex h-full flex-col items-center justify-center py-10">
                <LookAndFeel />
                {/* <h3 className="text-xl font-semibold text-red-400">
                    This page is not ready yet. Just press the save button below to start using the app.
                </h3>
                <img src="/assets/images/illustrations/under-construction.png" width={300} height={300} alt="under construction" /> */}
            </div>
            <div className="mt-6 flex justify-end gap-4">
                <Button variant="default" onClick={handleSave}>
                    Finish
                </Button>
            </div>
        </>
    );
};

export default Step3;
